import { useState } from "react";
import { useForm } from "react-hook-form";
import Form from "../../../components/Form";
import DynamicFormRenderer from "../../../components/DynamicFormRenderer";
import { vieIntakeFormConfig } from "./formConfig";
import Api from "../../../Api";

const VIEIntake = (props) => {
  const { metadata: { brandColors } } = vieIntakeFormConfig;
  const [loading, setLoading] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [showModalError, setShowModalError] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    unregister,
    reset,
    control,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {},
    shouldFocusError: true,
    criteriaMode: "all",
  });

  const submitForm = async (data) => {
    try {
      setLoading(true);

      await Api.dossiers.Create({
        defDossier: vieIntakeFormConfig.metadata.defDossier,
        ...data,
      });

      setLoading(false);
      setShowModalSuccess(true);
    } catch (error) {
      console.error("Form submission error:", error);
      setLoading(false);
      setShowModalError(true);
    }
  };

  return (
    <>
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
          <div className="relative">
            <div
              className="h-16 w-16 rounded-full border-4 animate-spin"
              style={{ borderColor: brandColors.border, borderTopColor: brandColors.accent }}
            ></div>
          </div>
        </div>
      )}

      {showModalError && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4">
            <div className="fixed inset-0 bg-gray-900 bg-opacity-75" onClick={() => setShowModalError(false)}></div>
            <div className="relative bg-white rounded-2xl shadow-xl p-6 w-full max-w-md mx-auto text-center">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
                <svg className="h-8 w-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <p className="text-lg font-medium text-gray-900 mb-6">
                Er is een fout opgetreden bij het verzenden.
              </p>
              <button
                onClick={() => setShowModalError(false)}
                className="px-6 py-3 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-600 transition-all"
              >
                Probeer opnieuw
              </button>
            </div>
          </div>
        </div>
      )}

      {showModalSuccess && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4">
            <div className="fixed inset-0 bg-gray-900 bg-opacity-75" onClick={() => setShowModalSuccess(false)}></div>
            <div className="relative bg-white rounded-2xl shadow-xl p-6 w-full max-w-md mx-auto text-center">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full mb-4" style={{ backgroundColor: `${brandColors.accent}20` }}>
                <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: brandColors.accent }}>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="text-lg font-medium text-gray-900 mb-6">
                Uw formulier is succesvol verzonden!
              </p>
              <button
                onClick={() => {
                  setShowModalSuccess(false);
                  reset();
                }}
                className="px-6 py-3 text-white font-semibold rounded-lg transition-all"
                style={{ backgroundColor: brandColors.accent }}
              >
                Sluiten
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="min-h-screen" style={{ backgroundColor: "#f8f9fa", fontFamily: "Arial, sans-serif" }}>
        <div className="max-w-[980px] mx-auto py-10 px-4">
          <div className="bg-white rounded-xl shadow-md p-6 sm:p-8">
            {/* Header */}
            <div className="relative mb-8 min-h-[95px]">
              {/* Logo placeholder - top right */}
              <div className="absolute top-0 right-0">
                {/* <img src={VieLogo} alt="VIE Logo" className="h-20" /> */}
              </div>
              <div className="text-center pt-10">
                <h1
                  className="text-3xl font-bold"
                  style={{ color: brandColors.primary }}
                >
                  Intakeformulier Energiecontract
                </h1>
                <p className="mt-1.5" style={{ color: brandColors.textLight, fontSize: "0.95em" }}>
                  VIE &ndash; Verbindingen Integratie &amp; Educatie
                </p>
              </div>
            </div>

            <Form
              {...props}
              register={register}
              handleSubmit={handleSubmit}
              setValue={setValue}
              unregister={unregister}
              formState={{ errors }}
              onSubmit={submitForm}
              defDossier={vieIntakeFormConfig.metadata.defDossier}
              reset={reset}
              skipLinkedContainers={true}
            >
              <DynamicFormRenderer
                config={vieIntakeFormConfig}
                register={register}
                errors={errors}
                setValue={setValue}
                unregister={unregister}
                control={control}
                watch={watch}
              />
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default VIEIntake;
